import { render, staticRenderFns } from "./Variants.vue?vue&type=template&id=ef0ec168&scoped=true&"
import script from "./Variants.vue?vue&type=script&lang=js&"
export * from "./Variants.vue?vue&type=script&lang=js&"
import style0 from "./Variants.vue?vue&type=style&index=0&id=ef0ec168&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0ec168",
  null
  
)

export default component.exports